<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd == 'add'">Tambah Free Tools</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Free Tools</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
									<v-autocomplete :disabled="propAdd == 'edit'" outlined dense  @focus="() => errorResponse.product_id=''" :error-messages="errorResponse.product_id" v-model="paramAdd.product_id" :items="product" item-text="product_name" item-value="product_id" label="Nama Produk" placeholder="Silahkan pilih produk" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
									<v-currency-field outlined dense @focus="() => errorResponse.quantity=''" :error-messages="errorResponse.quantity" v-model="paramAdd.quantity" label="Jumlah"></v-currency-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			paramAdd: {
				product_id: '',
				quantity: '',
			},
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object
	},
	computed: {
		...mapState('freeTools', ['errorResponse', 'responSukses', 'notInFreeTools', 'product']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapMutations('freeTools', ['konfirmasiSukses']),
		batal() {
			this.dialog = false
			this.konfirmasiSukses('')
		},
		simpan(){
			this.$emit('action', this.paramAdd)
		}
	},
	watch: {
		val () {
			Object.assign(this.paramAdd, this.val)
			if (this.propAdd == 'edit') {
				this.notInFreeTools.push({
					product_id: this.val.product_id,
					product_name: this.val.product_name,
				})
			}
		}
	},
	created() {
	}
}
</script>
